module.exports = __webpack_public_path__ + "static/img/list_menu.2017cab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/comMenu/images/list_menu.png
// module id = YKhY
// module chunks = 11